import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';
import { FiPlus } from 'react-icons/fi';
import Button from '../../Button';
import { outlineGray } from '../../../config/colors';
import EditImageView from '../../EditImage';

export const ViewsAndLayoutsListItemWrapper = styled.li`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

export const ImageAndRemoveWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
`;

export const ViewsAndLayoutsListItemImage = styled.img`
  width: 300px;
  height: 245px;
`;

export const ImageTitle = styled.h3`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
`;

export const RemoveImageBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '30px',
    height: '30px',
    marginTop: '10px',
    marginRight: '15px',
    position: 'absolute',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'white',
    size: '18px',
  },
})``;

export const NoImageContainer = styled.div`
  width: 300px;
  height: 245px;
  border: darkGrey 1px solid;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-itemrs: center;
  &:hover {
    background-color: whiteSmoke;
    cursor: pointer;
  }
`;

export const PlusSymbol = styled(FiPlus)`
  color: darkGrey;
  align-self: center;
  width: 100px;
  height: 100px;
`;

export const SelectImageTxt = styled.p`
  text-align: center;
  font-size: 1.429rem;
  margin-top: 20px;
  color: darkGrey;
`;

export const EditTitle = styled.input`
  width: 100%;
  height: 40px;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 1rem;
  text-align: start;
  margin-top: 20px;
  margin-bottom: 50px;
`;

export const EditImage = styled(EditImageView).attrs((props) => ({
  containerStyle: {
    width: '300px',
    height: '245px',
  },
}))``;
